const PushTemplate = {
  pushTemplate: 'Push Template',
  addPushTemplate: 'Add Push Template',
  editPushTemplate: 'Edit Push Template',
};
export default PushTemplate;
